import { useQuery } from '@tanstack/react-query';

import { users } from '../../api';
import { toast } from 'react-toastify';

export const useGetUserSettings = ({ slug }) => {
       return useQuery(['user-settings'], () => users.settings(slug), {
        enabled: !slug,
        onError: (error) => {
            toast.error(error.response?.data?.message);
        },
    });
};
